import { FC, ReactNode } from "react";

import Flogo from "../../assets/logo2.png";
// import Flogo from "@funded-here-interface/common/src/assets/synlian_logo.png";
import { useStyles } from "./AcknowledgementLayout.styles";

interface IProps {
  content: ReactNode;
  showLogo?: boolean;
  /** Paints the pale FundedHere illustration behind the page instead of flat
   * white. Opt-in because this layout backs ~10 screens across both apps and
   * only the auth-flow ones take the treatment. Defaults to false. */
  brandBackground?: boolean;
}

const AcknowledgementLayout: FC<IProps> = ({
  content,
  showLogo = true,
  brandBackground = false,
}) => {
  const { classes, cx } = useStyles();

  return (
    <div className={cx(classes.container, brandBackground && classes.brandBackground)}>
      {showLogo && (
        <div className={classes.iconContainer}>
          <img className={classes.logo} src={Flogo} alt="" />
        </div>
      )}
      <div className={classes.leftContainer}>
        <div className={classes.pageContainer}>
          <div className={classes.stepContent}>{content}</div>
        </div>
      </div>
    </div>
  );
};

export default AcknowledgementLayout;
